import { createSlotRecipe } from './runtime';

const paginationConfig = {"name":"pagination","slots":["root","range","pages","page","ellipsis"]}

export const pagination = /* @__PURE__ */ createSlotRecipe(paginationConfig)